import escape from 'lodash/escape';

export default value => escape(value);
